import React from 'react'
import './ProgressBullets.scss'

const getBullets = (key, makeActive) =>{

    if(makeActive){
        return  <li key={key} className="active"></li>
    }
    else{
        return  <li key={key}></li>
    }
}

export const ProgressBullets = (props) => { 

    var steps = [...Array(props.steps)];
    var currentStep = props.currentStep;
    return (              
        <ul className="progressbar" >
           { steps.map((x, index)=> getBullets(index, currentStep===index))}           
        </ul>
    );
  };
  